<template>
    <div>
        <div class="mb-4">
            <h5>{{ $t(`평가신청 기업 정보`) }}</h5>
            <!--      lg 이상의 화면의 경우          -->
            <b-table-simple bordered class="d-none d-lg-table bgray-100" fixed>
                <b-tbody>
                    <template>
                        <b-tr>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`업체코드`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.vendor_code || '  -  '
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`기업명 및 소재지`)
                                    }}</p>
                                <div>
                                    <h6 v-show="$i18n.locale === 'ko'"
                                        class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{ selected_vendor.company.company_name_dip }} /
                                        {{ selected_vendor.company.country_en }}</h6>
                                    <h6 v-show="$i18n.locale !== 'ko'"
                                        class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.company_name_en_dip
                                        }} / {{
                                            selected_vendor.company.country_en
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td v-if="tenant_register">
                                <p class="f-90 gray-600 fw-400 mb-1">
                                    {{ $t(`원청사`) }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.hd_corporate || '  -  '
                                        }}</h6>
                                </div>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`법인등록번호`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.corporate_code || '-'
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`사업자등록번호`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.company_code || '-'
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">
                                    {{ $t(`DUNS Number`) }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{ selected_vendor.duns_number || '-' }}</h6>
                                </div>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>
            <!--      lg 보다 작은 화면의 경우          -->
            <b-list-group no-gutters class="d-block d-lg-none">
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`기업명 및 소재지`) }}</p>
                    <div>
                        <h6 v-show="$i18n.locale === 'ko'"
                            class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.company_name_dip }} /
                            {{ selected_vendor.company.country }}</h6>
                        <h6 v-show="$i18n.locale !== 'ko'"
                            class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.company_name_en_dip }} /
                            {{ selected_vendor.company.country_en }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="tenant_register">
                    <p class="f-90 gray-600 fw-400 mb-1">
                        {{ $t(`원청사`) }}
                    </p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.hd_corporate || '-' }}
                        </h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`업체코드`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.vendor_code }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`법인등록번호`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.corporate_code || '-' }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`사업자등록번호`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.company_code || '-' }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`DUNS Number`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.duns_number || '-' }}</h6>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>


        <div class="fw-500 pb-1" autofocus>
            <span v-if="phase_step === 2">*</span> {{ $t(`이메일 (로그인 ID)`) }}
        </div>

        <b-form-input id="register-user-email"
                      v-model.trim="form.e_mail"
                      :disabled="phase_step === 2 || calcLoading"
                      placeholder="ex. email@email.com"
                      autocomplete="new-password"
                      @keypress.enter="handleNext"
        >
        </b-form-input>

        <template v-if="phase_step === 2 && !is_user_duplicated">
            <div class="pt-3 pb-1">* {{ $t(`성함`) }}</div>
            <b-form-input v-model.trim="form.user_name" :placeholder="$t(`성함`)"
                          :disabled="calcLoading"
            />

            <div class="pt-3 pb-1">* {{ $t(`비밀번호`) }}</div>
            <b-form-input v-model.trim="form.password" :placeholder="$t(`4자리 이상`)"
                          type="password"
                          autocomplete="new-password"
                          :disabled="calcLoading"
            />

            <div class="pt-3 pb-1">* {{ $t(`비밀번호 확인`) }}</div>
            <b-form-input
                v-model.trim="form.password_2"
                type="password"
                :placeholder="$t(`비밀번호 한번 더 입력`)"
                aria-describedby="password_check_feedback"
                autocomplete="new-password"
                :disabled="calcLoading"
                :state="!form.password || !form.password_2 ? null : form.password === form.password_2"
            />
            <b-form-invalid-feedback id="password_check_feedback">
                {{ $t(`비밀번호를 동일하게 입력해 주세요`) }}
            </b-form-invalid-feedback>

            <div class="d-flex">
                <div class="w-25 mr-3">
                    <div class="pt-3 pb-1">* {{ $t(`국가 코드`) }}</div>
                    <b-form-select id="input-company_country"
                                   v-model="form.national_code"
                                   :options="nation_codes"
                                   :text-field="$i18n.locale ===  'ko' ? 'text' : 'text_en'"
                                   value-field="value"
                                   :disabled="calcLoading"
                                   autocomplete="new-password"
                    >
                    </b-form-select>
                </div>

                <div class="w-75">
                    <div class="pt-3 pb-1">* {{ $t(`연락처`) }}</div>
                    <b-form-input v-model.trim="form.tel_office"
                                  aria-describedby="national-code-help-block"
                                  :placeholder="form.national_code === null ? `(+${($t('국가 코드'))}) 000-0000-0000` : '000-0000-0000'"
                                  :disabled="calcLoading"
                                  autocomplete="new-password"
                    />
                </div>
            </div>
        </template>
        <template v-if="phase_step === 2">
            <template v-if="!selected_vendor.validated">
                <div class="pt-3 pb-1">* {{ $t(`사업자등록번호`) }}</div>
                <!-- 회사에 이미 번호가 있으면 보여주기만 한다. 서버도 다른 값으로 바꾸는 요청은 거부한다 -->
                <b-form-input
                    v-if="existing_company_code"
                    :value="existing_company_code"
                    disabled
                />
                <b-form-input
                    v-else
                    v-model.trim="form.company_code"
                    :placeholder="$t(`사업자등록번호`)"
                    autocomplete="new-password"
                />
            </template>

            <template v-if="!has_service_request">
                <div class="pt-3 pb-1">* {{ $t(`결과보고서 희망 언어`) }}</div>
                <b-form-select v-model="form.report_lang"
                               :options="report_lang_options"
                               :disabled="calcLoading"
                               @change="report_lang_touched = true"
                />
            </template>

            <template v-if="input_keys?.length > 0">
                <ProjectInputForm v-model="form" :input_keys="input_keys"
                                  :loading="calcLoading"
                />
            </template>
            
        </template>
        <template v-else-if="phase_step === 3 && is_user_duplicated">
            <div class="mt-3">
                <h5>{{ $t('이미 회원가입 하신 사용자이므로 3초후 평가신청 단계로 진행됩니다.') }}</h5>
            </div>
        </template>


        <InputConfirmModal :input_keys="input_keys"
                           :form="form"
                           @confirm="confirmSelection"
                           @cancel="cancelSelection"
        />

        <PrivacyAgree v-model="privacy_agree"
                      @goNext="agreedPrivacy"
        />

        <CommonRegisterFooter>
            <b-btn v-if="!is_project_duplicated"
                   variant="blue"
                   :disabled="!selected_vendor || calcLoading"
                   @click="handleNext"
            >
                {{ $t(`다음`) }}
            </b-btn>
        </CommonRegisterFooter>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import CommonRegisterFooter from '@/components/auth/Register/_SubComponents/CommonRegisterFooter.vue';
import {mapActions, mapState} from 'vuex';
import * as Sentry from '@sentry/vue';
import PrivacyAgree from '@/components/auth/Register/_SubComponents/RegisterStep2/PrivacyAgree.vue';
import InputConfirmModal from '@/components/auth/Register/_SubComponents/RegisterStep2/InputConfirmModal.vue';
import {inputKeyDescriptionHtml} from '@/components/auth/Register/_SubComponents/RegisterStep2/inputKeyDescription';
import {tenant, mergeTenantRegister} from '@shared/utils/tenant';
import {access_status_mapping, nation_codes} from '@/components/auth/Register/_SubComponents/data';
import ProjectInputForm from '@/components/auth/Register/_SubComponents/RegisterStep2/ProjectInputForm.vue';
import {waitTime} from '@shared/utils/common';
import {localize} from 'vee-validate';

export default {
    name: 'RegisterStep2',
    components: {InputConfirmModal, ProjectInputForm, PrivacyAgree, CommonRegisterFooter},
    data() {
        return {
            form: {
                e_mail: '',
                user_name: '',
                password: '',
                password_2: '',
                tel_office: '',
                national_code: null,
                company_code: null,
                // 결과보고서 희망 언어 — 직접 고르기 전까지 화면 언어를 따라간다
                report_lang: this.$i18n.locale,
            },
            report_lang_touched: false,
            // 이 회사·프로젝트의 신청(df_nice_service_request)이 이미 있으면 true.
            // 결과보고서 희망 언어는 신청을 처음 만드는 사람만 고른다.
            has_service_request: false,
            input_keys: null,
            user_checked: false,
            is_user_duplicated: false,
            privacy_agree: false,
            selectionConfirmed: false,
            loading: false,
            campaign_id: null,
            /**
             * 규칙셋 기반 캠페인 판별이 필요한데 준비되지 않은 프로젝트인지 여부.
             * true 면 어떤 값을 입력해도 신청이 실패하므로 진행을 막는다.
             */
            campaign_resolution_blocked: false,
            /**
             * Phase Step
             * 1. 사용자 중복 체크
             * 2. 입력 값 입력
             * 3. 평가 신청
             */
            phase_step: 1,


        };
    },
    computed: {
        tenant_register() {
            return mergeTenantRegister(tenant && tenant.register, this.remote_register_config);
        },
        // 재확인 게이트 — confirmGate 테넌트(steel)에서 기준 설명 있는 input_key 가 있을 때만
        hasCriteriaInputs() {
            if (!this.tenant_register || !this.tenant_register.confirmGate) return false;
            const locale = this.$i18n.locale;
            return (this.input_keys || []).some(item => !!inputKeyDescriptionHtml(item, locale));
        },
        ...mapState('register', ['register_loading', 'register_step', 'selected_vendor', 'is_project_duplicated', 'remote_register_config']),
        access_status_mapping() {
            return access_status_mapping;
        },
        nation_codes() {
            return nation_codes;
        },
        calcLoading(){
            return this.register_loading || this.loading;
        },
        existing_company_code() {
            return this.selected_vendor?.company?.company_code?.trim() || null;
        },
        // 첫 신청(미검증 벤더)인데 회사에 사업자번호가 없을 때만 입력받는다
        company_code_input_needed() {
            return !this.selected_vendor.validated && !this.existing_company_code;
        },
        report_lang_options() {
            return [
                {text: '한국어', value: 'ko'},
                {text: 'English', value: 'en'},
                {text: '中文', value: 'ca'},
            ];
        }
    },
    watch: {
        '$i18n.locale'(locale) {
            if (!this.report_lang_touched) this.form.report_lang = locale;
        },
    },
    created() {
        this.fetchProjectInputKeys();
        if(this.selected_vendor?.company?.country){
            this.form.national_code = this.nation_codes.find(item => {
                return item.text.includes(this.selected_vendor.company.country);
            })?.value || null;
        }
    },
    methods: {
        ...mapActions('register', ['setRegisterLoading','setRegisterStep', 'setIsConflictRegister', 'setIsProjectDuplicated', 'setDuplicatedMessage']),
        async fetchProjectInputKeys() {
            this.loading = true;

            try {
                // project_id와 company_id를 통하여 이미 캠페인이 할당되었는지 체크
                
                const check_campaign_assign_res = await this.$axios.get('/register/company_project', {
                    params: {
                        project_id: this.selected_vendor.project,
                        company_id: this.selected_vendor.company.id,
                    }
                });
                
                if(check_campaign_assign_res.status === 200){
                    const campaignInfo = check_campaign_assign_res.data;
                    this.campaign_id = campaignInfo.id;
                    this.has_service_request = true;
                    return;
                }
                
                const res = await this.$axios.get(`/project-schema/projects/${this.selected_vendor.project}/schema`);

                const {input_keys, campaign_resolution} = res.data;

                // 이 프로젝트가 campaign_rule_sets 로 캠페인을 판별해야 하는데
                // 판별에 필요한 입력키가 준비되지 않은 경우.
                //
                // 이때 input_keys 는 빈 배열로 오는데, 이는 "추가 입력이 필요 없는
                // 정상 프로젝트" 와 응답이 동일하다. 프론트는 규칙셋 존재 여부를 알 수
                // 없으므로 예전에는 그대로 진행 → campaign_id: null 로 신청 →
                // 백엔드 422 를 받았다 (prod 2026-07-23). 백엔드가 알려주는
                // campaign_resolution 으로 여기서 끊는다.
                //
                // 차단 시점이 여기인 이유: 이메일/비밀번호/연락처/개인정보 동의를
                // 받기 전이라, 실패가 확정된 신청에 개인정보를 수집하지 않는다.
                //
                // 판정은 `ready` 하나만 본다. `ready` 는 백엔드가 "지금 이 프로젝트로
                // 신청이 가능한가" 를 register.py 와 **동일한 기준**으로 계산해 준
                // 값이다. `required`(판별 입력을 받아야 하는가)로 함께 걸면,
                // "규칙셋이 전부 비활성이고 단일 캠페인 매핑도 없는" 경우
                // (required=false, ready=false) 를 놓친다.
                if (campaign_resolution && !campaign_resolution.ready) {
                    this.campaign_resolution_blocked = true;
                    this.showCampaignResolutionBlockedModal();
                    return;
                }

                for (let i = 0; i < input_keys.length; i++) {
                    const item = input_keys[i];

                    if (item.value_type === 'list') {
                        item.allowed_values = item.allowed_values.map(value => {
                            return {
                                ...value,
                                label_ko: value.label_texts.ko,
                                label_en: value.label_texts.en,
                                label_ca: value.label_texts.ca,
                            };
                        });
                      
                    }
                    this.$set(this.form, item.key_name, null);
                }
                this.input_keys = input_keys;
            } catch (e) {
                this.$showModal({
                    type: 'alert',
                    state: 'error',
                    title: this.$t('평가 신청 오류'),
                    message: this.$t('평가 신청에 필요한 정보를 받아오는데 실패했습니다. 다시 시도해주시거나 에러가 지속적으로 발생 시, QESG로 문의해주세요.'),
                });
            } finally {
                this.loading = false;
            }
        },
        showCampaignResolutionBlockedModal() {
            this.$showModal({
                type: 'alert',
                state: 'error',
                title: this.$t('평가 신청 오류'),
                message: this.$t('프로젝트 설정이 완료되지 않아 현재 평가를 신청할 수 없습니다. QESG로 문의해주세요.'),
            });
        },
        agreedPrivacy(){
            this.phase_step = 3;
            this.$bvModal.hide('register-privacy-agree');
            this.handleNext();
        },
        // 재확인 모달: [확인하고 계속] → 플래그 set 후 기존 흐름 재개
        async confirmSelection() {
            this.selectionConfirmed = true;
            this.$bvModal.hide('register-input-confirm');
            await this.handleNext();
        },
        // 재확인 모달: [다시 선택] → 모달만 닫고 폼 유지(플래그 false 유지)
        cancelSelection() {
            this.selectionConfirmed = false;
        },
        async handleNext() {
            // 모달을 닫고 계속 진행하려는 경우에도 막는다 (신청은 반드시 실패한다).
            if (this.campaign_resolution_blocked) {
                this.showCampaignResolutionBlockedModal();
                return;
            }

            this.loading = true;

            try {
                if (this.phase_step === 1) {
                    // Phase1: 사용자 중복 체크
                    await this.userDuplicateCheck();
                } else if (this.phase_step === 2 && this.is_user_duplicated) {
                    // Phase2-1: 등록 사용자인 경우, 회원 정보 입력 폼 생략

                    if (this.company_code_input_needed) {
                        if(!this.validateAndFormattingCompanyCode())
                            return;
                    }
                    if(this.input_keys?.length > 0){
                        if (!this.projectKeyValidationCheck()) {
                            return;
                        }
                    }

                    // 캠페인 결정 항목(기업 규모 등) 재확인 (1회, confirmGate 테넌트)
                    if (this.hasCriteriaInputs && !this.selectionConfirmed) {
                        this.$bvModal.show('register-input-confirm');
                        return;
                    }

                    this.phase_step = 3;
                    await waitTime(2500);
                    await this.handleNext();

                } else if (this.phase_step === 2 && !this.is_user_duplicated) {
                    // Phase2-2: 미등록 사용자인 경우, 회원 정보 입력 및 개인정보 동의 받기
                    if (!this.formValidationCheck()) {
                        return;
                    }
                    
                    // 해당 vendor_code가 validated 상태가 아니고 회사에 번호가 없으면 사업자등록번호 받기
                    if (this.company_code_input_needed) {
                        if(!this.validateAndFormattingCompanyCode())
                            return;
                    }
                    if(this.input_keys?.length > 0){
                        if (!this.projectKeyValidationCheck()) {
                            return;
                        }
                    }

                    // 캠페인 결정 항목(기업 규모 등) 재확인 (1회, confirmGate 테넌트)
                    if (this.hasCriteriaInputs && !this.selectionConfirmed) {
                        this.$bvModal.show('register-input-confirm');
                        return;
                    }

                    this.$bvModal.show('register-privacy-agree');
                } else if (this.phase_step === 3 && this.privacy_agree) {
                    // 사업자등록번호는 /register/request 가 신청과 같은 트랜잭션에서 저장한다
                    const project_input_form = {};
                    this.input_keys?.forEach(item => {
                        project_input_form[item.key_name] = this.form[item.key_name];
                    });
                    
                    this.$emit('toRequestAssessment', {
                        form: this.form,
                        project_input_form: project_input_form,
                        is_user_duplicated: this.is_user_duplicated,
                        campaign_id: this.campaign_id,
                    });
                }
            } catch (error) {
                console.dir(error);
                let sentry_error_message = null;
                this.setIsConflictRegister(true);

                if (error.response) {
                    const {status, data} = error.response;
                    if (status === 409) {
                        sentry_error_message = data.message;
                        if (data.message === 'Duplicated_Project_Request') {
                            this.setIsConflictRegister(false);
                            this.setIsProjectDuplicated(true);
                            let _duplicatedMessage = {...data.request};
                            _duplicatedMessage.create_date = dayjs(_duplicatedMessage.create_date).format('YYYY년 M월 D일 HH:mm:ss');
                            _duplicatedMessage.create_date_e = dayjs(_duplicatedMessage.create_date).locale('en').format('DD/MM/YYYY ddd HH:mm:ss');
                            _duplicatedMessage.access_date = dayjs(_duplicatedMessage.access_date).format('YYYY년 M월 D일 HH:mm:ss');
                            _duplicatedMessage.access_date_e = dayjs(_duplicatedMessage.access_date).locale('en').format('DD/MM/YYYY ddd HH:mm:ss');

                            this.setDuplicatedMessage(_duplicatedMessage);
                            
                            this.$emit('duplicatedRequest', this.form.e_mail);
                        }
                    }
                } else {
                    sentry_error_message = error.message;
                }
                this.setRegisterStep(3);
                // Sentry Register 실패 Breadcrumb 추가
                Sentry.addBreadcrumb({
                    level: 'Error',
                    type: 'Auth',
                    category: 'Register',
                    data: {
                        email: this.form.e_mail,
                        vendor_code: this.selected_vendor?.vendor_code,
                        company_name: this.selected_vendor?.company?.company_name,
                        message: sentry_error_message
                    }
                });
            } finally {
                this.loading = false;
            }
        },
        async userDuplicateCheck() {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (this.isFieldEmpty(this.form.e_mail) || !emailRegex.test(this.form.e_mail)) {
                alert(this.$t('이메일을 정확히 입력하여 주십시오.'));
                return false;
            }
            if (this.user_checked === false) {
                // e_mail 기준 회원가입 유무 확인
                let _res_user = await this.$axios.get('/register/verification_user_project', {
                    params: {
                        email: this.form.e_mail,
                        vendor_code: this.selected_vendor?.vendor_code,
                        project_code: this.selected_vendor?.project_code,
                        company_id: this.selected_vendor?.company?.id,
                        company_code: this.selected_vendor?.company?.company_code,
                        corporate_code: this.selected_vendor?.company?.corporate_code,
                        duns_number: this.selected_vendor?.company?.duns_number
                    }
                });

                const {user} = _res_user.data;


                this.user_checked = true;
                this.is_user_duplicated = !!user;

                this.phase_step = 2;
                
                // 기가입 유저, 평가신청만 자동 진행 
                if (this.is_user_duplicated) {
                    this.privacy_agree = true;
                    if(this.campaign_id != null){
                        await this.handleNext();
                    }
                }
            }
        },
        formValidationCheck() {
            if (!this.form.e_mail || !this.form.user_name || !this.form.password || !this.form.tel_office) {
                alert(this.$t('회원가입에 필요한 필수정보를 입력해주세요.'));
                return false;
            }

            if ((!this.form.password && !this.form.password_2) || (this.form.password !== this.form.password_2)) {
                alert(this.$t('비밀번호 확인을 위해 정확히 기재해주세요.'));
                return false;
            }
            return true;
        },
        projectKeyValidationCheck() {
            for (let i = 0; i < this.input_keys.length; i++) {
                const item = this.input_keys[i];

                if (item.is_required) {
                    if (this.form[item.key_name] === null || this.form[item.key_name] === '') {
                        alert(this.$t(`필수 입력 항목인 ${item.label_texts?.[this.$i18n.locale] || item.label_texts?.ko}을(를) 입력해주세요.`));
                        return false;
                    }
                }
            }
            return true;
        },
        checkCorporateRegiNumber(number) {
            const numberMap = number.replace(/-/gi, '').split('').map(d => parseInt(d, 10));

            if (numberMap.length === 10) {
                let keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5]; //사업자번호 유효성 확인하는 일반 코드임
                let chk = 0;

                keyArr.forEach(function (d, i) {
                    chk += d * numberMap[i];
                });

                chk += parseInt((keyArr[8] * numberMap[8]) / 10, 10);
                // console.log(Math.floor(numberMap[9]) === ( (10 - (chk % 10) ) % 10));
                return Math.floor(numberMap[9]) === ((10 - (chk % 10)) % 10);
            } else {
                return false;
            }
        },
        validateAndFormattingCompanyCode() {
            if (this.isFieldEmpty(this.form.company_code)) {
                alert(this.$t('사업자 코드를 입력해주세요.'));
                return false;
            }

            const cleanCompanyCode = this.form.company_code.trim();
            const isKo = this.$i18n.locale === 'ko';

            if (isKo) {
                if(!this.checkCorporateRegiNumber(cleanCompanyCode)){
                    this.showOverseasBusinessNumberModal();
                    return false;
                }
                return true;
            }

            return true;
        },
        // 한국어 UI 에서 한국 사업자등록번호 체크섬에 실패한 경우:
        // 해외(대한민국 외) 등록 기업일 수 있으므로, alert 로 막지 않고
        // 언어를 English 로 전환하도록 유도한다. 전환해도 입력값은 유지된다
        // (locale 반응형 대입 + localize 만 수행, 리로드/재마운트 없음).
        showOverseasBusinessNumberModal() {
            const h = this.$createElement;
            const message = h('div', [
                h('p', {class: 'mb-2'}, '입력하신 번호는 대한민국 사업자등록번호로 확인되지 않습니다. 대한민국 외 국가에 등록된 기업이라면 화면 언어를 English 로 변경한 뒤 다시 신청해 주세요. 입력하신 정보는 그대로 유지됩니다.'),
                h('p', {class: 'mb-0 text-secondary'}, 'This number is not recognized as a Korean business registration number. If your company is registered outside Korea, switch the language to English and continue. Your entered information will be kept.'),
            ]);
            this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '사업자등록번호 확인 / Business Registration Number',
                message,
                modalOptions: {
                    okTitle: 'English 로 전환 / Switch to English',
                    cancelTitle: '닫기 / Close',
                },
            }).then((confirmed) => {
                if (confirmed) {
                    this.$i18n.locale = 'en';
                    localize('en');
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
